import { React, useState, useEffect, useContext } from "react";
import "./../styles/QueueContent.css";
import "./../styles/Tabs.css";
import { Button } from "./Button";
import { BasicTableClinical } from "./ClinicalDashboardTable";
import { Link, useHistory } from "react-router-dom";
import { ApiCall } from "../../utility/ApiCalls";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import PersonIcon from "@mui/icons-material/Person";
import AutoProcessedDialog from "../userHome/AutoProcessedDialog";
import { Box } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ClearIcon from "@mui/icons-material/Clear";
import Api_Call from "../../ApiCall";
import ErrorPage from "../Common/ErrorPage";
import menus from "../../user-config.json";
import UserContext from "../Common/UserContext";
import info from "./../../info.json";
import LetterPopUp from "../userHome/LetterPopUp";
import CustomModal from "./AuditModalBox";
import NoteIcon from "@mui/icons-material/Note";
import ConfirmationModal from "../Common/ConfirmationModal";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
export const ClinicalQueueContent = ({ activeStyle, ...props }) => {
  const history = useHistory();
  const taskBtn = props.taskBtn;
  const completedListFlag = props.completedListFlag;
  const [loader, setLoader] = useState(false);
  const [caseactivityData, setCaseactivityData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [linkForAudited, setLinkforAudited] = useState(false);
  const [columnData, setcolumnData] = useState();
  const [taskid, setTaskid] = useState(sessionStorage.getItem("ActiveTaskID"));
  const [error, setError] = useState(false);
  const { userRole } = useContext(UserContext);
  const { userRole: user } = useContext(UserContext);

  const [lettersData, setlettersData] = useState([]);
  const [isLettersOpen, setLettersOpen] = useState(false);
  const [
    activeTaskIdAfterLetterIconclick,
    setActiveTaskIdAfterLetterIconclick,
  ] = useState("");
  const [isPdfVisible, setIsPdfVisible] = useState(false);
  const [isCrossClickedOnLetterPopup, setIsCrossClickedOnLetterPopup] =
    useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [letterUrl, setLetterUrl] = useState();

  const [isOpenInprogressToComplete, setisOpenInprogressToComplete] =
    useState(false);
  const [caseIdForEditClicked, setcaseIdForEditClicked] = useState();

  const [isConfirmClicked, setIsconfirmClicked] = useState(false);
  useEffect(() => {
    if (isCrossClickedOnLetterPopup) setLettersOpen(true);
  }, [isCrossClickedOnLetterPopup]);

  // console.log(history);

  useEffect(() => {
    if (
      (user == "Nurse" || user == "Supervisor") &&
      activeStyle.audited &&
      linkForAudited
    ) {
      history.replace("/ClinicalReviewAudit");
    }
  }, [history, user]);

  //  useEffect(()=>{
  //   console.log(props.taskQueueData)
  //   if(props.taskQueueData.length>0 && taskid!=null)
  //   {
  console.log("CONFIRM CLICKED->", isConfirmClicked);

  //   //    set3columnData(taskQueue.filter(item => ({
  //   //     Dispute_ID: item.Dispute_ID,
  //   //     RaisedOn: item.RaisedOn,
  //   //     Dispute_Status: item.Dispute_Status
  //   // })))

  //   console.log(props.taskQueueData.filter(item => item["Task_ID"]==taskid))
  //   const { Dispute_ID, RaisedOn, Dispute_Status } = props.taskQueueData.filter(item => item["Task_ID"]==sessionStorage.getItem('ActiveTaskID'))[0]
  //     setcolumnData({Dispute_ID,RaisedOn,Dispute_Status});
  //    console.log({Dispute_ID,RaisedOn,Dispute_Status})
  //     sessionStorage.setItem(sessionStorage.getItem("ActiveTaskID")+'THCols',JSON.stringify({Dispute_ID,RaisedOn,Dispute_Status}))
  //   }
  // },[props.taskQueueData.length,taskid)

  var colums = [
    {
      width: 100,
      Header: "Task ID",
      accessor: "Task_ID",
      Cell: (props) => {
        // console.log( props)
        return (
          <>
            {taskBtn ? (
              props.row.values.Task_ID
            ) : activeStyle.audited ? (
              <span className="link" onClick={startAuditedTask}>
                {props.row.values.Task_ID}
              </span>
            ) : (
              <span
                className="link"
                onClick={(e) => {
                  sessionStorage.setItem(
                    "ActiveTaskID",
                    props.row.values.Task_ID
                  );
                  startPendingTask(e);
                }}
              >
                {props.row.values.Task_ID}
              </span>
            )}
          </>
        );
      },
    },
    {
      width: 100,
      Header: "Priority",
      accessor: "Priority",
    },
    {
      width: 150,
      Header: "Member ID",
      accessor: activeStyle.audited ? "Member_ID" : "MemberID_CR",
    },
    activeStyle.audited
      ? ""
      : {
          width: 150,
          Header: "Member Name",
          accessor: "MemberName",
        },
    !activeStyle.audited && {
      width: 150,
      Header: "Auth ID",
      accessor: "Auth_ID",
    },
    //completedListFlag &&
    activeStyle.audited
      ? ""
      : {
          width: 150,
          Header: "Status",
          accessor: "Status_CR",
          //   Cell: props => {
          //     return <>{<div>{props.row.values.Status}</div>}</>;
          //   }
        },
    //completedListFlag &&
    activeStyle.audited
      ? ""
      : {
          width: 92,
          Header: "Received Date/Time",
          accessor: "TaskCreateDate_DT",
          Cell: (props) => {
            return <>{<div>{props.row.values.TaskCreateDate_DT}</div>}</>;
          },
        },
    completedListFlag
      ? ""
      : {
          width: activeStyle.audited ? 92 : 150,
          Header: activeStyle.audited
            ? "Completed Date/Time"
            : "Assigned Date/Time",
          accessor: activeStyle.audited ? "completedOn" : "AssignedDateTime",
        },
    completedListFlag && {
      width: activeStyle.audited ? 92 : 150,
      Header: activeStyle.audited
        ? "Completed Date/Time"
        : "Completed Date/Time",
      accessor: activeStyle.audited ? "completedOn" : "Case_Completed",
      Cell: (props) => {
        return (
          <>
            {activeStyle.audited ? (
              <div>{props.row.values.completedOn}</div>
            ) : (
              <div>{props.row.values.Case_Completed}</div>
            )}
          </>
        );
      },
    },
    {
      width: 150,
      Header: activeStyle.audited ? "Score" : "TAT",
      accessor: activeStyle.audited ? "Score" : "tat",
    },
    activeStyle.completed &&
      info.LETTER_GENERATION && {
        width: 150,
        Header: "View Letters",
        accessor: "",
        Cell: (props) => {
          return (
            <NoteIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                letterClickHandler(props.row.values.Task_ID);
                setActiveTaskIdAfterLetterIconclick(props.row.values.Task_ID);
              }}
            ></NoteIcon>
          );
        },
      },
    activeStyle.inprogress && {
      width: 150,
      Header: "Action",
      accessor: "",
      Cell: (props) => {
        console.log(props);
        return (
          <button
            className="icon-disabled"
            style={{
              cursor: "pointer",
              border: "unset",
              backgroundColor: "unset",
            }}
            onClick={() => {
              setisOpenInprogressToComplete(true);
              setcaseIdForEditClicked(props.row.original.Task_ID);
            }}
            disabled={props.row.original.Direct_Close == "0"}
          >
            {" "}
            <BorderColorRoundedIcon></BorderColorRoundedIcon>
          </button>
        );
      },
    },
  ].filter((item) => item);

  async function startTask() {
    try {
      setLoader(true);
      const api = new Api_Call();
      const data = await api.getData(
        "TASK/START_TASK?taskID=&module_name=clinicalreview"
      );
      if (data.statusCode != 200) {
        throw new Error("Fetching Data Failed");
      }
      console.log(data);
      sessionStorage.setItem("ActiveTaskID", data.body);
      var redirectPath = "/ClinicalReview";
      console.log("I am in completed task");
      history.push(redirectPath);
    } catch (error) {
      console.error(error.message);
      setError(error);
    } finally {
      setLoader(false);
    }

    // const ret = await ApiCall(
    //   {
    //     taskID: "",
    //     clinical_status: "1",
    //   },
    //   "vcare-ui",
    //   "agent_starttask"
    // );

    // const response = ret.body;
    // if (response) {
    //   setLoader(false);
    // }
    // console.log("response from start task ", response);
    // sessionStorage.setItem("ActiveTaskID", response);
    // var redirectPath = "/ClinicalReview";
    // console.log("I am in completed task");
    // history.push(redirectPath);
  }

  const letterClickHandler = async (taskId) => {
    setLettersOpen(true);
    setLoading(true);
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `LETTERS/GENERATION?taskID=${taskId}&letter_id=`
      );
      console.log(data.body["letter_details"]);
      setlettersData(data.body["letter_details"]);
    } catch (error) {
      console.log("Error Occured");
    } finally {
      setLoading(false);
    }
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const OnEditPressed = async () => {
    const api = new Api_Call();
    const data = await api.postData(`CLINICAL-REVIEW/SUBMIT`, {
      SaveType: "19",
      Task_ID: caseIdForEditClicked,
      user_id: sessionStorage.getItem("UserID"),
    });
    props.taskQueueInprogressApi();

    console.log(data);
  };

  async function startPendingTask(e) {
    // setLoader(true);
    console.log("Pending tasks clicked----", e);
    try {
      setLoader(true);
      const api = new Api_Call();
      const data = await api.getData(
        `VALIDATIONS/GET-DATA?taskID=${sessionStorage.getItem(
          "ActiveTaskID"
        )}&clinical_data=${menus[userRole.toLowerCase()].clinical}` // Vlaue can be 0 or 1;
      );
      console.log("Api called");
      if (data.statusCode != 200) {
        throw new Error("Fetching Data Failed");
      }
      console.log(data);
      // sessionStorage.setItem("ActiveTaskID", data.body.Task_ID);
      const activeTile = Object.keys(activeStyle).find(
        (key) => activeStyle[key] === true
      );
      var redirectPath = `/ClinicalReview?activeTile=${activeTile}`;
      console.log(activeStyle);
      history.push(redirectPath);
    } catch (error) {
      console.error(error.message);
      setError(error);
    } finally {
      setLoader(false);
    }
    // console.log("task ID from Queue 2", e.currentTarget.textContent);
    // const ret = await ApiCall(
    //   {
    //     taskID: e.currentTarget.textContent,
    //     clinical_data: "1",
    //   },
    //   "vcare-ui",
    //   "agent_getvalidatedtask"
    // );
    // const response = ret.body.Task_ID;
    // if (response) {
    //   setLoader(false);
    // }
    // sessionStorage.setItem("ActiveTaskID", response);
    // const activeTile = Object.keys(activeStyle).find(
    //   (key) => activeStyle[key] === true
    // );
    // var redirectPath = `/ClinicalReview?activeTile=${activeTile}`;
    // console.log(activeStyle);
    // history.push(redirectPath);
  }

  async function startAuditedTask(e) {
    setLinkforAudited(true);
    sessionStorage.setItem("ActiveTaskID", e.currentTarget.textContent);
    console.log(sessionStorage.getItem("ActiveTaskID"));

    setTaskid(sessionStorage.getItem("ActiveTaskID"));
    // setLoader(true);
    // console.log('task ID from Queue 2', e.currentTarget.textContent);
    // const ret = await ApiCall(
    //   {
    //     taskID: e.currentTarget.textContent,
    //     clinical_data: "1",
    //   },
    //   "vcare-ui",
    //   "agent_getvalidatedtask"
    // );
    // const response = ret.body.Task_ID;
    // if (response) {
    //   setLoader(false);
    // }
    // sessionStorage.setItem("ActiveTaskID", response);
    // var redirectPath = "/ClinicalReviewAudit";

    var redirectPath = "/ClinicalReviewAudit";
    if (user == "Auditor") {
      redirectPath = "/ClinicalAudit";
    }
    history.push(redirectPath);
  }

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (props.type === "supervisor" || props.type === "admin") {
      props.setAssigned(props.dataSupervisorAssigned.length);
      props.setUnassigned(props.dataSupervisorUnassigned.length);
    }
  }, []);
  if (error) {
    return <ErrorPage code={error.code} message={error.message}></ErrorPage>;
  }

  return (
    <>
      <div className="content-main">
        <div className="user-content-container">
          {props.taskBtn ? (
            <div className="button-div">
              <Button
                buttonStyle="btn--primary"
                buttonSize="btn--medium"
                onClick={startTask}
              >
                Start Next Task
              </Button>
            </div>
          ) : (
            ""
          )}
          <Box className="tasklist-table">
            <BasicTableClinical
              activeStyle={activeStyle}
              columns={colums}
              tableData={props.taskQueueData}
              tableType="default"
              AddButtonText=""
            ></BasicTableClinical>
          </Box>
          <LetterPopUp
            open={isLettersOpen}
            onClose={() => setLettersOpen(false)}
            lettersData={lettersData}
            isLoading={isLoading}
            setLettersOpen={setLettersOpen}
            activeTaskId={activeTaskIdAfterLetterIconclick}
            setIsPdfVisible={setIsPdfVisible}
            setModalOpen={setModalOpen}
            setLetterUrl={setLetterUrl}
            setIsCrossClickedOnLetterPopup={setIsCrossClickedOnLetterPopup}
          ></LetterPopUp>

          {isPdfVisible && (
            <CustomModal
              isOpen={isModalOpen}
              onClose={closeModal}
              urlpdF={letterUrl}
              setLetterUrl={setLetterUrl}
              setIsCrossClicked={setIsCrossClickedOnLetterPopup}
            />
          )}
          <ConfirmationModal
            isOpen={isOpenInprogressToComplete}
            onClose={() => {
              setisOpenInprogressToComplete(false);
            }}
            onConfirm={() => {
              OnEditPressed();
              setIsconfirmClicked(true);
              setisOpenInprogressToComplete(false);
              // props.taskQueueInprogressApi();
            }}
            message=" Do you want to mark Case Complete"
          ></ConfirmationModal>
        </div>
      </div>
      {loader ? (
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      ) : (
        ""
      )}
    </>
  );
};
